<div class="table-row">
  <div class="table-item hide-on-med-and-down">{{ item.rank }}</div>
  <div class="table-item">
    {{ item.name }}
  </div>
  <div class="table-item">
    {{ item.surname }}
  </div>
  <div class="table-item">
    {{ item.completedCoursesCount }}
  </div>
  <div class="table-item">
    {{ item.totalMedalsCount }}
  </div>
  <div class="table-item">
    {{ item.score }}
  </div>
</div>
